import { lazy } from 'react';
export const TalkdeskChatIcons = {
  chat: lazy(() => import('./chat-icon')),
  chatMobile: lazy(() => import('./chat-mobile-icon'))
};
export const TalkdeskNetspendChatIcons = {
  chatNetspend: lazy(() => import('./chat-netspend-icon'))
};